export default function setExternalReleaseAction (externalRelease) {

    return {
        type: 'SET_EXTERNALRELEASE_ERROR',
        payload: externalRelease
    }
}